export const API_PATH = 'invoice-reports/companies';

export const API_BASE = process.env.FINANCIAL_DOCS_API;

export const INVOICE_REPORT_API_PATH = (companyId: string, invoiceId: string) =>
  `${API_PATH}/${companyId}/invoices/${invoiceId}`;

export const INVOICE_REPORT_DOWNLOAD_API_PATH = (
  companyId: string,
  invoiceId: string,
) => `${INVOICE_REPORT_API_PATH(companyId, invoiceId)}/download`;

export const INVOICE_REPORT_EMPLOYEES_API_PATH = (
  companyId: string,
  invoiceId: string,
) => `${INVOICE_REPORT_API_PATH(companyId, invoiceId)}/employees`;

export const INVOICE_REPORT_EMPLOYEE_API_PATH = (
  companyId: string,
  invoiceId: string,
  employeeId: string,
) => `${INVOICE_REPORT_EMPLOYEES_API_PATH(companyId, invoiceId)}/${employeeId}`;

export const INVOICE_REPORT_EMPLOYEE_BREAKDOWN_API_PATH = (
  companyId: string,
  invoiceId: string,
  employeeId: string,
) =>
  `${INVOICE_REPORT_EMPLOYEE_API_PATH(companyId, invoiceId, employeeId)}/breakdown`;

export const INVOICE_REPORT_APPROVE_API_PATH = (
  companyId: string,
  invoiceId: string,
) => `${INVOICE_REPORT_API_PATH(companyId, invoiceId)}/approve`;

export const INVOICE_REPORT_FORCE_SYNC_API_PATH = (
  companyId: string,
  invoiceId: string,
) => `${INVOICE_REPORT_API_PATH(companyId, invoiceId)}/force-sync`;
